import { React, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Alert from "@mui/material/Alert";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { InputMask } from '@react-input/mask';
import api from '../../services/api';
import Loading from "../Layout/Loading";
import imgDelete from '../../img/delete01.png';
import imgCheck from '../../img/check01.png';

function Boleto(){


    //#region constantes
    const navigate = useNavigate();

    const location = useLocation();

    const [dadosGerais, setDadosGerais] = useState({});
    const [boleto, setBoleto] = useState({});
    
    const [showLoading, setShowLoading] = useState(false);

    const [msgInfo, setMsgInfo] = useState("");
    const [msgAviso, setMsgAviso] = useState("");
    
    /* Constantes para controlar o foco do mouse nos botões */
    const [isHoverVisualizar, setIsHoverVisualizar] = useState(false);
    const [isHoverVoltar, setIsHoverVoltar] = useState(false);
    const [isHoverGravarNumero, setIsHoverGravarNumero] = useState(false);

    const [fone01, setFone01] = useState("");
    const [fone02, setFone02] = useState("");

    const [isVisibleImgDelete01, setIsVisibleImgDelete01] = useState(true);
    const [isVisibleImgCheck01, setIsVisibleImgCheck01] = useState(false);

    const [isVisibleImgDelete02, setIsVisibleImgDelete02] = useState(true);
    const [isVisibleImgCheck02, setIsVisibleImgCheck02] = useState(false);

    const [isFoneInformado, setIsFoneInformado] = useState(false);
    const [isFoneGravado, setIsFoneGravado] = useState(false);

    //#endregion 


    //#region handle mouse
    const handleMouseEnterVisualizar = () => {
        setIsHoverVisualizar(true);
    };

    const handleMouseLeaveVisualizar = () => {
        setIsHoverVisualizar(false);
    };

    const handleMouseEnterVoltar = () => {
        setIsHoverVoltar(true);
    };

    const handleMouseLeaveVoltar = () => {
        setIsHoverVoltar(false);
    };

    const handleMouseEnterGravarNumero = () => {
        setIsHoverGravarNumero(true);
    };

    const handleMouseLeaveGravarNumero = () => {
        setIsHoverGravarNumero(false);
    };

    //#endregion



    //#region functions

    function Voltar(){
        navigate("/taxacusteio");
    }

    function changeFone01(e){
        
        setFone01(e.target.value);

        setIsVisibleImgDelete01(e.target.value.trim().length !== 14);
        setIsVisibleImgCheck01(e.target.value.trim().length === 14);

        setIsVisibleImgDelete02(e.target.value.trim().length !== 14 || e.target.value.trim() !== fone02);
        setIsVisibleImgCheck02(e.target.value.trim().length === 14 && isVisibleImgCheck01 && e.target.value.trim() === fone02);

        if(e.target.value.trim().length === 14 && isVisibleImgCheck01 && e.target.value.trim() === fone02){
            setIsFoneInformado(true);
        }else{
            setIsFoneInformado(false);
        }
    }

    function changeFone02(e){

        setFone02(e.target.value);

        //const lengthFone01 = fone01.trim().length;

        setIsVisibleImgDelete02(e.target.value.trim().length !== 14 || e.target.value.trim() !== fone01);
        setIsVisibleImgCheck02(e.target.value.trim().length === 14 && isVisibleImgCheck01 && e.target.value.trim() === fone01);

        if(e.target.value.trim().length === 14 && isVisibleImgCheck01 && e.target.value.trim() === fone01){
            setIsFoneInformado(true);
        }else{
            setIsFoneInformado(false);
        }
    }

    function GravarNumero(){
        
        const body = {
            FONE: fone01,
            ID_USUARIO: 1
        }

/*
        setShowLoading(true);

        setTimeout(() => {
*/
            api.patch(`cadastro/boletos/atualizafonecomunicarregistro/${boleto.ID_BOLETO}`, body)
                .then((res) => {

                    setShowLoading(false);
                    setIsFoneGravado(true);
                    
                })
                .catch((err) => {
                    if(err.response.data.RESULT){
                        alert(err.response.data.RESULT);
                    }else{
                        alert(err.response.data);
                    }
                    setShowLoading(false);
                });
/*
        }, 500);
*/    
    }

    //#endregion
    


    //#region useEffect
    useEffect(() => {

        setDadosGerais(location.state.dadosgerais);
        setBoleto(location.state.boleto);

    }, []);
    //#endregion



    //#region html
    return (
        <div>
            {
                (Object.keys(dadosGerais).length > 0) ? (

                    <div className="form-control"
                        style={{padding:"10px 10px 0 10px",
                                textAlign:'center',
                                backgroundColor:'#fff',
                                height:'89.9vh',
                                overflow:'auto'}}>

                        {!showLoading ? (

                            <div className="form-control">
                            
                                <div className="cnpjcpf-content-container" 
                                        style={{backgroundColor:'#fff',
                                                marginBottom:'0.5rem'}}>

                                    {/* Titulo */}
                                    <div style={{fontSize:'24px',
                                                    color:'#423c89',
                                                    backgroundColor:'#fff',
                                                    marginBottom:'0.5rem'}}>
                                        <h3>Boleto gerado com sucesso!</h3>
                                    </div>

                                    {/* Corpo */}
                                    <div style={{fontSize:'16px',
                                                backgroundColor:'#fff',
                                                marginBottom:'0.5rem'}}>
                                        
                                        {/* Dados da empresa */}
                                        <div style={{backgroundColor:'gray', 
                                                        width:'100%',
                                                        margin:'auto',
                                                        color:'white',
                                                        borderRadius:'0.5rem'}}>
                                            Dados da empresa
                                        </div>

                                        {/* CNPJ */}
                                        <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:'bold'}}>CNPJ:</span>
                                            <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.CNPJ}</span>
                                        </div>

                                        {/* NOME_FANTASIA */}
                                        <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:'bold'}}>Nome Fantasia:</span>
                                            <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.NOME_FANTASIA}</span>
                                        </div>

                                        {/* RAZAO_SOCIAL */}
                                        <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:'bold'}}>Razão social:</span>
                                            <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.RAZAO_SOCIAL}</span>
                                        </div>

                                        {/* Opções */}
                                        <div style={{backgroundColor:'gray', 
                                                        width:'100%',
                                                        margin:'auto',
                                                        color:'white',
                                                        borderRadius:'0.5rem',
                                                        marginTop:'1rem'}}>
                                            Dados do boleto
                                        </div>

                                        <div style={{width:'300px',
                                                     backgroundColor:'silver',
                                                     margin:'auto',
                                                     marginTop:'1rem',
                                                     borderRadius:'0.5rem'}}>

                                            <div style={{fontWeight:'bold',fontSize:'1.5rem',textDecoration:'underline'}}>Boleto</div>
                                            <div>
                                                <div style={{display:'inline-block',fontSize:'1.5rem'}}>Número:</div>
                                                <div style={{display:'inline-block',color: '#2957A4',fontSize:'1.5rem',marginLeft:'0.5rem'}}>{boleto.ID_BOLETO}</div>
                                            </div>
                                            <div>
                                                <div style={{display:'inline-block',fontSize:'1.5rem'}}>Valor:</div>
                                                <div style={{display:'inline-block',color: '#2957A4',fontSize:'1.5rem',marginLeft:'0.5rem'}}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(boleto.VALOR_ORIGINAL)}</div>
                                            </div>
                                            <div>
                                                <div style={{display:'inline-block',fontSize:'1.5rem'}}>Vencimento:</div>
                                                <div style={{display:'inline-block',color: '#2957A4',fontSize:'1.5rem',marginLeft:'0.5rem'}}>{boleto.VENCIMENTO}</div>
                                            </div>

                                            <Alert icon={<WarningAmberIcon />}
                                                    severity="warning"
                                                    style={{width:'96%',
                                                            margin:'auto',
                                                            marginTop:'0.5rem',
                                                            marginBottom:'0.5rem',
                                                            textAlign:'justify'}}>
                                                        {`Este boleto precisa ser registrado junto aos sistemas bancários e este processo pode levar alguns minutos ou até 1 dia útil. Se desejar, informe seu número de celular abaixo que iremos lhe enviar um SMS assim que este processo for concluído. Neste SMS também enviaremos o link para acessar o boleto quando necessário.`}
                                            </Alert>
                                        

                                            {/* DIV dos botões */}
                                            <div>
                                                <div>

                                                    {/* Visualizar boleto */}
                                                    <a href={boleto.LINK_BOLETO} target="_blank">
                                                        <button style={{backgroundColor: isHoverVisualizar ? '#0033EA' : '#2957A4',
                                                                        width:'160px', 
                                                                        display:'inline-block',
                                                                        height:'28px',
                                                                        alignContent: 'center',
                                                                        cursor:'pointer',
                                                                        margin:'auto',
                                                                        color:'white',
                                                                        borderRadius:'0.5rem',
                                                                        borderWidth:'0.2rem',
                                                                        borderStyle:'solid',
                                                                        borderColor:isHoverVisualizar ? '#0033EA' : '#2957A4', 
                                                                        //marginLeft:'5px',
                                                                        marginTop:'1rem'}}
                                                            onMouseEnter={handleMouseEnterVisualizar}
                                                            onMouseLeave={handleMouseLeaveVisualizar}>
                                                                Visualizar boleto
                                                        </button>
                                                    </a>
                                                </div>
                                                <div>
                                                    <button style={{backgroundColor: isHoverVoltar ? '#2957A4' : '#fff',
                                                            width:'160px', 
                                                            display:'inline-block',
                                                            height:'28px',
                                                            alignContent: 'center',
                                                            cursor:'pointer',
                                                            margin:'auto',
                                                            color: isHoverVoltar ? '#fff' : 'black',
                                                            //marginRight:'5px',
                                                            borderRadius:'0.5rem',
                                                            borderWidth:'0.2rem',
                                                            borderStyle:'solid',
                                                            borderColor:'#2957A4',
                                                            marginTop:'1rem',
                                                            marginBottom:'1rem'}}
                                                        onMouseEnter={handleMouseEnterVoltar}
                                                        onMouseLeave={handleMouseLeaveVoltar}
                                                        onClick={Voltar}>
                                                            Voltar
                                                    </button>
                                                </div>
                                            </div>

                                            
                                            {/* DIV dos campos para número do celular */}
                                            <div style={{}}>
                                                <div style={{backgroundColor:'white',margin:'auto',width:'96%',borderRadius:'0.3rem',padding:'0.2rem'}}>
                                                    <span>Informe seu número de celular aqui para receber um SMS com a confirmação do registro deste boleto</span>
                                                </div>
                                                <div style={{marginTop:'0.3rem'}}>
                                                    
                                                    <div style={{display:'inline-block',
                                                                 width:'70%'}}>
                                                        <InputMask mask="(__)_____-____" 
                                                            replacement={{ _: /\d/ }} 
                                                            showMask={false}
                                                            id="edtFone01"
                                                            name="edtFone01"
                                                            placeholder='Fone celular'
                                                            inputMode='numeric'
                                                            style={{width:'200px',textAlign:'center'}}
                                                            onChange={changeFone01}
                                                            disabled={isFoneGravado}
                                                            />
                                                        
                                                    </div>
                                                    {
                                                        isVisibleImgDelete01 ? (
                                                            <img src={imgDelete} alt="imgDelete01" />
                                                        ): null
                                                    }
                                                    {
                                                        isVisibleImgCheck01 ? (
                                                            <img src={imgCheck} alt="imgCheck01" />
                                                        ): null
                                                    }
                                                    

                                                </div>
                                                <div style={{marginTop:'0.3rem'}}>

                                                    <div style={{display:'inline-block',width:'70%'}}>
                                                        <InputMask mask="(__)_____-____" 
                                                                replacement={{ _: /\d/ }} 
                                                                showMask={false}
                                                                id="edtFone02"
                                                                name="edtFone02"
                                                                placeholder='Repita o fone'
                                                                inputMode='numeric'
                                                                style={{width:'200px',textAlign:'center'}}
                                                                onChange={changeFone02}
                                                                disabled={isFoneGravado}
                                                                />
                                                    </div>
                                                    {
                                                        isVisibleImgDelete02 ? (
                                                            <img src={imgDelete} alt="imgDelete02" />
                                                        ): null
                                                    }
                                                    {
                                                        isVisibleImgCheck02 ? (
                                                            <img src={imgCheck} alt="imgCheck02" />
                                                        ): null
                                                    }
                                                </div>

                                            </div>

                                            {/* DIV botão gravar número */}
                                            <div>
                                                <button style={{backgroundColor: isFoneGravado ? 'green' : isFoneInformado ? isHoverGravarNumero ? '#0033EA' : '#2957A4' : 'gray',
                                                                width:'160px', 
                                                                display:'inline-block',
                                                                height:'28px',
                                                                alignContent: 'center',
                                                                cursor: isFoneGravado ? 'default' : isFoneInformado ? 'pointer' : 'default',
                                                                margin:'auto',
                                                                color:'white',
                                                                borderRadius:'0.5rem',
                                                                borderWidth:'0.2rem',
                                                                borderStyle:'solid',
                                                                borderColor: isFoneGravado ? 'green' : isFoneInformado ? isHoverGravarNumero ? '#0033EA' : '#2957A4' : 'gray', 
                                                                marginTop:'1rem'}}
                                                    disabled={!isFoneInformado || isFoneGravado}
                                                    onMouseEnter={handleMouseEnterGravarNumero}
                                                    onMouseLeave={handleMouseLeaveGravarNumero}
                                                    onClick={GravarNumero}>
                                                        {
                                                            isFoneGravado ? `Fone gravado!` : `Gravar número`
                                                        }
                                                </button>
                                            </div>

                                            <br />

                                            {
                                                (msgInfo) ? (
                                                    <Alert icon={<InfoOutlineIcon />}
                                                            severity="info"
                                                            style={{width:'98%',
                                                                    margin:'auto',
                                                                    marginBottom:'1rem' }}>
                                                        {msgInfo}
                                                    </Alert>

                                                ) : null
                                            }

                                            {
                                                (msgAviso) ? (
                                                    <Alert icon={<WarningAmberIcon />}
                                                            severity="warning"
                                                            style={{width:'98%',
                                                                    margin:'auto',
                                                                    marginBottom:'1rem' }}>
                                                        {msgAviso}
                                                    </Alert>

                                                ) : null
                                            }

                                        </div>

                                    </div>

                                </div>
                            
                            </div>

                        ) :  <Loading />}
                    </div>

                ): (
                    <div>Carregando...</div>
                )
            }

        </div>
    )
    //#endregion


};

export default Boleto;
